import { NextPage } from 'next'
import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'

import { selectors } from '../redux'
import Router from '../routes/Router'
import routes from '../routes/definitions'

const PreviewGuard = (Page: NextPage<any>): FC<any> => {
  return function PreviewGuard(props) {
    const router = useRouter()
    const routeId = router.query?.id
    const id = useSelector(selectors.preview.id)
    const classified = useSelector(selectors.preview.classified)

    useEffect(() => {
      if (!routeId || !id || routeId != id) {
        Router.pushRoute(routes.classifieds)
      }
    }, [routeId, id, router])

    if (!routeId || !id || !classified || routeId != id) {
      return null
    }

    return <Page {...props} classified={classified} />
  }
}

export default PreviewGuard
